/**
 * Connection Creator specific type definitions
 * Isolated from main app types for CC module independence
 */

export enum DrawerId {
    // Data nodes
    ModifyField = "ccModifyField",
    Set = "ccSet",

    // Communication nodes
    HttpMethod = "ccHttpMethod",
    Http = "ccHttp",
    Webhook = "ccWebhook",

    // Flow nodes
    Start = "ccStart",
    End = "ccEnd",
    Wait = "ccWait",
    Repeater = "ccRepeater",
    Breaker = "ccBreaker",
    SubScenario = "ccSubScenario",
    Mirror = "ccMirror",

    // Edge/Connection
    Condition = "ccCondition",
}

export enum FormId {
    // Data nodes
    ModifyFieldForm = "ccModifyFieldForm",
    SetForm = "ccSetForm",

    // Communication nodes
    HttpMethodForm = "ccHttpMethodForm",
    HttpForm = "ccHttpForm",
    WebhookForm = "ccWebhookForm",

    // Flow nodes
    StartForm = "ccStartForm",
    EndForm = "ccEndForm",
    WaitForm = "ccWaitForm",
    RepeaterForm = "ccRepeaterForm",
    BreakerForm = "ccBreakerForm",
    SubScenarioForm = "ccSubScenarioForm",
    MirrorForm = "ccMirrorForm",

    // Edge/Connection
    ConditionForm = "ccConditionForm",
}
